import React from "react";
import CalendarDatePicker from "ui/components/comp-507";

const JobTimesheetTagsFilters = ({ filters, setFilters }) => {

  return (
    <div>
      <CalendarDatePicker
        date={{
          from: filters.startDate,
          to: filters.endDate,
        }}
        setDate={(range) =>
          setFilters({ ...filters, startDate: range?.from, endDate: range?.to })
        }
      />
    </div>
  );
};

export default JobTimesheetTagsFilters;
